import { render, staticRenderFns } from "./debtDetails.vue?vue&type=template&id=f1b3c6ca&"
import script from "./debtDetails.vue?vue&type=script&lang=js&"
export * from "./debtDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports